<template>
  <div>
    <div class="about" align="center">
      <div class="container">
        <div class="about-content-wrap">
          <div class="image-wrap">
            <img
              src="../assets/shani-standing.png"
              alt="Responsive image"
              class="rounded img-fluid d-none d-md-block"
            />
            <img
              src="../assets/shani-standing-3.png"
              alt="Responsive image"
              class="img-fluid d-block d-md-none small-img"
            />
          </div>

          <div class="card about-card">
            <div v-if="!showExpandedLearnMore">
              <p>
                <vue-typed-js
                  :showCursor="false"
                  :fadeOutDelay="500"
                  :strings="['Hi,']"
                >
                  <h1 class="typing hi-text"></h1>
                </vue-typed-js>
              </p>
              <p>
                <vue-typed-js
                  :showCursor="false"
                  :startDelay="1000"
                  :strings="['I am Shani!']"
                  @onComplete="setShowDescription"
                >
                  <h1 class="typing name-text"></h1>
                </vue-typed-js>
              </p>
              <p v-show="showDescription" class="about-text" align="left">
                An entrepreneur, writer, international business woman, and an
                unshakable optimist dedicated to helping you become the person
                you most want to be.
              </p>
              <div class="vertical-center">
                <button
                  v-on:click="
                    showExpandedLearnMore = true;
                    showDescription = false;
                  "
                  v-show="showDescription"
                  type="button"
                  class="hideElement typing button btn-filled-white"
                >
                  Learn More
                </button>
              </div>
            </div>
            <div v-else>
              <h1 class="expandedLearnMoreTitleStyle">Shani Coaching</h1>
              <hr />
              <p class="expandedLearnMoreStyle">
                <span class="expandedLearnMoreStyleS">I</span>
                have spent my career helping individuals and organizations break
                free from the past and take control of their future. I help them
                transform the “victim mindset” to a growth mindset and create
                their reality. Career fulfillment and life coaching for
                professionals are my specialties.
              </p>
              <p class="expandedLearnMoreStyle">
                I was born and raised in Israel, served in the military, and
                moved to Europe at the age of 20. Living and working in 5
                different countries and traveling to 48 countries on my own
                taught me a lot about recreating myself and my reality. I lost
                and found myself more times than I can count.
              </p>
              <p class="expandedLearnMoreStyle">
                Combining theoretical knowledge with my experience in coaching
                professionals helped me master the tools and develop techniques
                to help ANYONE create the “best version of their life and
                themselves.”
              </p>
              <button
                v-on:click="showExpandedLearnMore = false"
                type="button"
                class="alignCenter hideElement typing button btn-filled-white"
              >
                <b-icon icon="arrow-left"></b-icon>
              </button>
              <a href="/#/services">
                <button
                  type="button"
                  style="margin-left: 1.5vh"
                  class="alignCenter hideElement typing button btn-filled-white"
                >
                  Let's go :)
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Footer from "../components/Footer";
export default {
  name: "About",
  data() {
    return {
      showDescription: false,
      showExpandedLearnMore: false,
    };
  },
  components: { Footer },
  methods: {
    setShowDescription() {
      setTimeout(() => {
        this.showDescription = true;
      }, 500);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "../../node_modules/rfs/scss";
.about {
  margin-top: 5em;
  @media screen and (min-width: 992px) {
    margin-top: 3em;
  }
}

.smallabout {
  margin-top: 5em;
}

.small-img {
  width: 100%;
}

.about-content-wrap {
  @media screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
  }
}

.image-wrap {
  img {
    height: 100%;
    object-fit: cover;
  }
}

.about-card {
  background-color: rgb(255, 231, 234);
  padding: 20px;

  @media screen and (min-width: 576px) {
    padding: 40px 20px;
  }

  @media screen and (min-width: 768px) {
    margin-top: 1em;
  }
}

.hi-text {
  margin-top: 0.5em;
  font-size: 7vh;
  font-style: italic;
}

.name-text {
  font-size: 3vh;
  text-transform: uppercase;
  letter-spacing: 3.5px;
}

.about-text {
  font-size: 3vh;
  line-height: 2;
  font-weight: 300;
}
.learnmore {
  margin-top: 40px;
  font-size: 4vh;
  // color: white !important;
}
.BackBtn {
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 1vh;
  color: white !important;
}
.learnmoresmall {
  margin-top: 0px;
  font-size: 4vh;
  // color: white !important;
}

.NiceFont {
  color: black;
  // font-family: Raleway;
  font-family: "Lato", sans-serif;

  /* font-size: 2em; */
  @include font-size(1em);
}
.expandedLearnMoreStyleS {
  // font-weight: 500;
  text-align: justify;
  @include font-size(2em);
  line-height: 1;
}
.expandedLearnMoreTitleStyle {
  margin-top: 3vh;
  @include font-size(2em);
  letter-spacing: 2.5px;
}
.expandedLearnMoreStyle {
  margin-top: 1vh;
  text-align: justify;
  @include font-size(1.3em);
  line-height: 1.5;
  font-weight: 300;
}
// .smallabout {
//   /* background-image: url( ${require('@/assets/smilenoview.png')}); */
// }
</style>
